import { useEffect, useMemo, useState } from 'react'
import { Button, Callout, LoadingState, Pill } from 'admination-react'
import { optimisticRemoveKey, useApp, useWithoutRemoved } from '@/core/state/appStore'
import { me } from '@/core/data/session'
import { listModulnCatalog, listModulUsageCounts, type ModulRow } from '../../data/modul'
import { ListView } from '@/core/views/ListView'
import { moduleViewConfigWithUsage } from './moduleViewConfig'

export function ModuleSection() {
  const { state, dispatch } = useApp()
  const [organisationId, setOrganisationId] = useState<string | null>(null)
  const [modules, setModules] = useState<ModulRow[]>([])
  const [usageRead, setUsageRead] = useState<{ key: string; counts?: Map<string, number>; failed?: boolean }>({ key: '' })
  const [retry, setRetry] = useState(0)
  const usageKey = JSON.stringify([organisationId, state.massnahmenVersion, retry])
  const result = usageRead.key === usageKey ? usageRead : undefined
  const usage = result?.counts ?? null

  useEffect(() => {
    let cancelled = false
    me()
      .then((m) => {
        if (!cancelled) setOrganisationId(m.organisationId)
      })
      .catch((e) => console.error("me() failed:", e))
    return () => {
      cancelled = true
    }
  }, [])

  useEffect(() => {
    if (!organisationId) return
    let cancelled = false
    listModulnCatalog(organisationId)
      .then((rows) => {
        if (!cancelled) setModules(rows)
      })
      .catch((e) => console.error("Module laden fehlgeschlagen:", e))
    return () => {
      cancelled = true
    }
  }, [organisationId, state.massnahmenVersion])

  useEffect(() => {
    if (!organisationId) return
    let cancelled = false
    listModulUsageCounts()
      .then((counts) => {
        if (!cancelled) setUsageRead({ key: usageKey, counts })
      })
      .catch(() => { if (!cancelled) setUsageRead({ key: usageKey, failed: true }) })
    return () => {
      cancelled = true
    }
  }, [organisationId, usageKey])

  const shown = useWithoutRemoved(modules, (m) => optimisticRemoveKey('modul', m.id))
  const config = useMemo(() => moduleViewConfigWithUsage(usage), [usage])

  const onRowClick = (m: ModulRow) => {
    const source = { kind: 'row' as const }
    dispatch({ type: 'OPEN_SCREEN', screen: { kind: 'modul', massnahmeId: null, modulId: m.id, tab: 'details', coachingId: null, source } })
  }

  return (
    <ListView
      items={shown}
      config={config}
      viewState={{ sort: state.moduleSort, search: state.moduleSearch, filter: state.moduleViewFilter }}
      header={!usage && (result?.failed ? (
        <Callout tone="error" role="alert">
          Die Verwendung der Module konnte nicht geladen werden.<Pill><Button onClick={() => setRetry((value) => value + 1)}>Erneut versuchen</Button></Pill>
        </Callout>
      ) : <LoadingState>Die Verwendung der Module wird geladen …</LoadingState>)}
      selectedKey={state.selectedMassnahmeId == null ? state.selectedModulId : null}
      onRowClick={onRowClick}
    />
  )
}
